import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  alpha,
  Stack,
  lighten,
  Divider,
  styled,
  useTheme,
  IconButton,
  Paper,
  Tooltip
} from '@mui/material';
import CoPresentIcon from '@mui/icons-material/CoPresent';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import InstallDesktopIcon from '@mui/icons-material/InstallDesktop';
import HeaderUserbox from './Userbox';
import { GridMenuIcon } from '@mui/x-data-grid';
import { SidebarContext } from '../../../contexts/SidebarContext';
import { CancelDeleteUserButton as PrimaryBtn } from '../../../components/Button';
import { ROLES } from '../../../constants';
import { useAppSelector } from '../../../state/store';
import { getUserRole } from '../../../state/user/userSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  height: 45,
  width: 45
}));

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 6;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
`
);


function Header() {
  const referralPath = '/referral';
  const theme = useTheme();
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const navigate = useNavigate();
  const userRole = useAppSelector(getUserRole);

  const trainingSupportButtonSx = {
    background: '#c5c5cb',
    '&:hover': { background: '#b5b5bd' },
    '&:focus': { background: '#b5b5bd' }
  };

  const shouldShowHeaderActions =
    userRole && userRole !== ROLES.ADMIN && userRole !== ROLES.TRIAL_USER;

  const handleReferralClick = () => {
    window.open(referralPath, '_blank', 'noopener,noreferrer');
  };

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        spacing={2}
      >
        <Item
          sx={{
            display: { lg: 'none', xs: 'inline-block' }
          }}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleSidebar}
            sx={{ marginLeft: 0.3, marginTop: 0.2 }}
          >
            <GridMenuIcon />
          </IconButton>
        </Item>
      </Stack>
      <Box display="flex" alignItems="center">
        {shouldShowHeaderActions && (
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              mr: 2,
              '& > *:not(:last-child)': { mr: 1 }
            }}
          >
            <PrimaryBtn
              size="small"
              className={'referral-button background-green'}
              startIcon={<ConnectWithoutContactIcon fontSize="small" />}
              onClick={handleReferralClick}
            >
              Referral
            </PrimaryBtn>
            <PrimaryBtn
              size="small"
              sx={trainingSupportButtonSx}
              startIcon={<CoPresentIcon fontSize="small" />}
              onClick={() => navigate('/training')}
            >
              Training
            </PrimaryBtn>
            <PrimaryBtn
              size="small"
              sx={trainingSupportButtonSx}
              startIcon={<SupportAgentIcon fontSize="small" />}
              onClick={() => navigate('/support')}
            >
              Support
            </PrimaryBtn>
            <PrimaryBtn
              size="small"
              sx={trainingSupportButtonSx}
              startIcon={<InstallDesktopIcon fontSize="small" />}
              onClick={() => navigate('/installation')}
            >
              Installation
            </PrimaryBtn>
          </Box>
        )}
        <HeaderUserbox />
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
